import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const scrollToDespre = () => {
  document.getElementById("despre")?.scrollIntoView({ behavior: "smooth" });
};

export const SmartHero = () => (
  <section id="acasa" data-testid="hero-section" className="relative overflow-hidden bg-white">
    <div className="absolute inset-0 bg-linegrid opacity-50" />
    <div className="absolute inset-x-0 bottom-0 h-px bg-slate-200" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-10 pt-24 pb-16 lg:pt-28 lg:pb-20">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-semibold text-ink leading-[1.0] text-5xl sm:text-6xl lg:text-7xl"
          >
            <span className="block">Proiectul</span>
            <span className="block">
              <span className="text-isic tracking-tight">SMART CAMPUS</span>
            </span>
          </motion.h1>
          <Reveal delay={0.15}>
            <p className="mt-7 max-w-xl text-lg text-slate-600 leading-relaxed">
              Soluție modernă de identificare și control acces în unitățile de învățământ preuniversitar.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-9">
              <button
                data-testid="hero-cta-primary"
                onClick={scrollToDespre}
                className="inline-flex items-center rounded-full bg-isic px-7 py-3.5 text-sm font-semibold text-white hover:bg-isic-dark transition-colors"
              >
                Vezi detalii
              </button>
            </div>
          </Reveal>
          <Reveal delay={0.35}>
            <div className="mt-10 flex items-center gap-3 text-sm text-slate-500">
              <span className="h-1.5 w-1.5 rounded-full bg-isic" />
              Implementat deja în peste 100 de școli, licee și colegii din Europa.
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 hidden md:flex justify-center lg:justify-end">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          >
            <svg viewBox="0 0 460 460" fill="none" className="w-full h-auto max-w-[440px]" aria-hidden="true">
              <circle cx="250" cy="205" r="150" fill="#0E9A94" opacity="0.05" />
              <g stroke="#E2E8F0" strokeWidth="1.5" fill="#FFFFFF">
                <rect x="120" y="120" width="46" height="120" rx="4" />
                <rect x="176" y="86" width="40" height="154" rx="4" />
                <rect x="226" y="132" width="52" height="108" rx="4" />
                <rect x="288" y="104" width="40" height="136" rx="4" />
              </g>
              <g fill="#0E9A94" opacity="0.35">
                <circle cx="196" cy="120" r="2.5" />
                <circle cx="196" cy="140" r="2.5" />
                <circle cx="308" cy="140" r="2.5" />
                <circle cx="308" cy="160" r="2.5" />
              </g>
              <line x1="70" y1="300" x2="400" y2="300" stroke="#E2E8F0" strokeWidth="1.5" />
              <rect x="176" y="298" width="13" height="92" rx="6" stroke="#CBD5E1" strokeWidth="1.5" fill="#FFFFFF" />
              <rect x="292" y="298" width="13" height="92" rx="6" stroke="#CBD5E1" strokeWidth="1.5" fill="#FFFFFF" />
              <rect x="189" y="318" width="103" height="7" rx="3.5" fill="#CBD5E1" />
              <rect x="284" y="286" width="28" height="19" rx="4" fill="#0E9A94" />
              <g stroke="#0E9A94" fill="none" strokeWidth="1.6" strokeLinecap="round">
                <path d="M320 288 q10 8 0 18" opacity="0.8" />
                <path d="M330 282 q17 14 0 30" opacity="0.5" />
                <path d="M340 276 q24 20 0 42" opacity="0.28" />
              </g>
              <path d="M96 402 C150 392 176 372 224 344" stroke="#CBD5E1" strokeWidth="1.6" strokeDasharray="2 8" strokeLinecap="round" />
              <circle cx="104" cy="398" r="6" fill="#0E9A94" />
            </svg>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
